import { createIcon } from "@chakra-ui/icons";

const ArrowLeft = createIcon({
  displayName: "ArrowLeft",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M19 12H5M5 12L12 19M5 12L12 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default ArrowLeft;
